import React from 'react';

import { styled, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';

const Button_IDP = styled(Button)(({ theme }) => ({
  borderRadius: '2em',
  padding: theme.spacing(3, 5),
  backgroundColor: theme.palette.background.primary,
  '&:hover': {
    backgroundColor: theme.palette.custom.grey_hover.background,
  },
  '& svg': {
    height: 18,
    width: 18,
  },
}));

const LoginIdpButton = ({ icon, label, onClick }) => (
  <Button_IDP startIcon={icon} onClick={onClick}>
    <Typography variant="h5" component="span">
      {label}
    </Typography>
  </Button_IDP>
);

LoginIdpButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default LoginIdpButton;
